import theme, { Spacing } from '../theme';

export const Layout = {
  SIDEBAR_DESKTOP_WIDTH: 270,
  SIDEBAR_MOBILE_WIDTH: 235,
  HEADER_HEIGHT: 70,
};
export const TablePadding = {
  padding: `${theme.spacing.xs} ${theme.spacing.xxs}`,
  'padding-left': theme.spacing.sm,
  'padding-right': theme.spacing.none,
};

export const DefaultLayoutPadding: Spacing = 'sm';

type SectionPadding = {
  Default: Spacing;
  Mobile: Spacing;
  Inbetween: Spacing;
};
export const DefaultSectionPadding: SectionPadding = {
  Default: 'xxl',
  Mobile: 'lg',
  Inbetween: 'xl',
};

export const ContentPadding = {
  padding: theme.spacing.xs,
};
export const InputLeftPadding = theme.spacing.sm;
